import React, { useEffect } from 'react'
import Bredcom from '../../Bredcom/Main'
import Header from '../../headerone/Main'
import Blog from '../../menhome/Blog'
import Newlast from '../../menhome/Newlast'
import Reporting from '../mencrimereport/Reporting'


function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Report Crime";
  }, [])

  return (
    <>
        <Header/>

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Home"
            title="report crime"
            subtitledown="Report Crime"
           />
            <Reporting/>
            <Blog/>
            <Newlast/>
        </div>
    </>
  )
}

export default Main